import { TEMPLATE_STATUS } from '../constants/messageTemplateKeys';

// Saving must preserve the template's existing status rather than demoting it to
// draft — an inactive template stays inactive, a published one stays published.
// New templates (no current status) default to draft.
// Active is the exception: editing it returns the template to published, so the save
// is a publish and must run publish-level validation instead of draft-level.
export function resolveSaveStatus(currentStatus) {
  if (currentStatus === TEMPLATE_STATUS.ACTIVE) return TEMPLATE_STATUS.PUBLISHED;
  return currentStatus ?? TEMPLATE_STATUS.DRAFT;
}
